<div class="modal-body content width-400 ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{data?.title}}
    </span>
		<div class="content">
			<span>{{data?.message}}</span>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="send(action.rtValue)" *ngFor="let action of data.actions"
			        class="md-btn"
			        [disabled]="action.disabled">
				{{action.btnText}}
			</button>
		</div>
	</div>
</div>
